import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';   
import './styles.css';

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AuthProvider>     {/* <-- WRAP THE ENTIRE APP */}
      <App />
    </AuthProvider>
  </BrowserRouter>
);
